import { AwardCommitteeMeeting } from '@tran-monorepo/interfaces';

// Intl is used instead of Angular's formatDate, which needs locale data registered synchronously.
const dateFormatter = new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});
const timeFormatter = new Intl.DateTimeFormat('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
});

export function formatAwardCommitteeMeetingDate(awardCommitteeMeeting: AwardCommitteeMeeting): string {
    const start = new Date(awardCommitteeMeeting.startDate);
    const end = new Date(awardCommitteeMeeting.endDate);
    return `${dateFormatter.format(start)} ${timeFormatter.format(start)} - ${timeFormatter.format(end)}`;
}
